import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'dealer-portal-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
  
export class DealerPortalHome implements OnInit, OnDestroy {
  constructor(
    private loginService: LoginService,
    private sanitizer: DomSanitizer,
  ) { }
  // current tab value
  tabSelectedIndex: number = 0

  effect = 'scrollx';
  carouselList: any[] = [];
  get carouselImageStyle(){
    const offsetWidth = document.getElementById('dealer-portal-right')?.offsetWidth || 0;
    const height = offsetWidth / 1920 * 720
    return {
      width: `100%`,
      height: `${height}px`
    }
  }
  // Init
  ngOnInit(): void {
    this.getBannerList()
  }
  // Destroy
  ngOnDestroy(): void {
  }
  getBannerList() {
    this.loginService.userData$.subscribe((userData: any) => {
      const isLogin = userData?.queryUserPageInfoResDTO?.status === 2;
      if(isLogin){
        this.loginService.getBannerTableList({
          size: 20,
          current: 1,
          title: '',
          status: 1,
          salesOrg: userData?.salesOrgVOList || [],
          isAdmin: false
        }).subscribe(result => {
          const { rtnCode, rtnData } = result;
          if (rtnCode === 10000 && rtnData) {
            const { total, records } = rtnData;
            this.carouselList = records || [];
            this.carouselList.forEach(row => {
              row.imageBase64 = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' + row.imageBase64);
            });
          }
        });
      }
    });
    // this.isSpinning = true;
    
  }
  
}
